(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-menu-desktop"] && !Shopify.designMode) return;
  try {
    (function () {
    var nav = document.getElementById('snav-list');
    if (!nav) return;

    function getMegamenuTop() {
      var navEl = nav.closest('.header__menu-desktop') || nav;
      return Math.round(navEl.getBoundingClientRect().bottom);
    }

    function applyTop() {
      var top = getMegamenuTop();
      nav.querySelectorAll('.snav-mega').forEach(function (el) {
        el.style.top = top + 'px';
      });
    }

    function closeAll() {
      nav.querySelectorAll('.snav-parent.is-open').forEach(function (item) {
        item.classList.remove('is-open');
        item.querySelector('.snav-btn').setAttribute('aria-expanded', 'false');
        item.querySelector('.snav-mega').setAttribute('aria-hidden', 'true');
      });
    }

    nav.querySelectorAll('.snav-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var item = btn.closest('.snav-parent');
        var wasOpen = item.classList.contains('is-open');
        closeAll();
        if (!wasOpen) {
          applyTop();
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          item.querySelector('.snav-mega').setAttribute('aria-hidden', 'false');
        }
      });
    });

    document.addEventListener('click', closeAll);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    window.addEventListener('resize', applyTop);
  })();
  } catch(e) { console.error(e); }
})();

})();
